import { render, staticRenderFns } from "./OrdemEstrutura.vue?vue&type=template&id=34f390b1&scoped=true"
import script from "./OrdemEstrutura.vue?vue&type=script&lang=js"
export * from "./OrdemEstrutura.vue?vue&type=script&lang=js"
import style0 from "./OrdemEstrutura.vue?vue&type=style&index=0&id=34f390b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f390b1",
  null
  
)

export default component.exports